// Computes the pool's starting tick so a launched token opens at a $2,000
// market cap against its paired token. The BluePad factory always deploys the
// new token as currency1 (paired token is currency0), so the opening price is
// deterministic from the pair's USD reference price and decimals.

const TOKEN_TARGET_USD = 2e-6; // $2,000 market cap / 1e9 supply

// Approximate USD reference prices used only to seed the opening tick.
export const PAIR_USD = {
  ETH: 3000,
  USDC: 1,
  cbBTC: 95000,
  AERO: 0.9,
  VIRTUAL: 1.1,
  DEGEN: 0.004,
  AAPLc: 230,
  NVDAc: 180,
  TSLAc: 340,
  METAc: 700,
  GOOGLc: 240,
};

export function computeInitialTick(pairSymbol, pairDecimals) {
  const pairUsd = PAIR_USD[pairSymbol];
  if (!pairUsd) return 0;
  // token is currency1, paired token is currency0:
  // price_raw = (tokens per paired) scaled by the decimal difference.
  const priceRaw = (pairUsd / TOKEN_TARGET_USD) * Math.pow(10, 18 - pairDecimals);
  return Math.round(Math.log(priceRaw) / Math.log(1.0001));
}
